import { GreenhouseDepartment } from "../types";

const filterByDepartment = (selectedDepartmentName: string) => (department: GreenhouseDepartment) =>
  selectedDepartmentName === "" || department.name === selectedDepartmentName;

export { filterByDepartment };
